<template>
  <div style="position: relative">
    <title-and-edit
      currentViewTitle="Favorittprodukter"
      @toggleEdit="toggleEdit"
      :edit="edit"
      :hideEditButton="!filteredProducts.length"
      :layout="layout"
    />
    <div class="profile__container--content__product primary-font pt-5">
      <div v-if="filteredProducts.length">
        <profile-dropdown
          v-if="layout == 'portal'"
          :items="chains"
          @select-item="updateProductList"
          :layout="layout"
        ></profile-dropdown>
        <div v-for="product in filteredProducts" :key="product.title">
          <product
            :layout="layout"
            :product="product"
            :edit="edit"
            @delete-product="updateProducts"
          ></product>
        </div>
        <div
          v-if="selectedChain !== '' && layout === 'portal'"
          class="d-flex justify-start"
        >
          <v-btn
            class="font-weight-bold secondary-font text-none my-6"
            color="primary"
            rounded
            outlined
            elevation="0"
            @click="webshopRedirect()"
          >
            <div>Finn flere i nettbutikk</div>
          </v-btn>
        </div>
      </div>
      <div v-else>
        <v-overlay
          :value="loading"
          color="white"
          absolute
          style="height: 600px"
        >
          <v-progress-circular
            color="var(--v-primary-base)"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <no-content
          v-if="!loading && !filteredProducts.length"
          title="Du har ingen favorittprodukter ennå."
          icon="fxt-products"
          hide-button
          :layout="layout"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Product from "./components/Product.vue";
import {
  ProfileDropdown,
  NoContent,
  TitleAndEdit,
} from "../../../Common/CommonComponents";
import ProfileSvc from "../../../../services/profile-svc";
let profileSvc = null;
export default {
  components: { Product, ProfileDropdown, NoContent, TitleAndEdit },
  props: {
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data: () => ({
    edit: false,
    loading: false,
    products: [],
    filteredProducts: [],
    chains: [],
    selectedChain: "",
  }),
  computed: {
    bookingApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        : process.env.VUE_APP_FIXIT_NO_BOOKING_URL;
    },
  },
  methods: {
    async updateProducts(product) {
      var result = await profileSvc.UpdateFavoriteProduct(
        this.bookingApi,
        product.productId,
        product.siteId
      );
      if (result) {
        this.products = await profileSvc.GetFavoriteProducts(
          this.bookingApi,
          this.layout == "chain"
            ? this.$store.getters["salon/getSiteIds"]
              ? this.$store.getters["salon/getSiteIds"]
              : this.$store.getters["site/getChainSiteIds"]
            : []
        );
        this.filteredProducts = this.products;
      }
    },
    /**
     * Update products displayed based on which chain is selected in the dropdown
     */
    updateProductList(chain) {
      this.filteredProducts =
        chain == "Alle"
          ? [...new Set(this.products)]
          : this.products.filter((x) => x.chainName == chain);
      this.selectedChain = chain;
    },
    toggleEdit() {
      this.edit = !this.edit;
    },
    webshopRedirect() {
      let chainId = this.products.find(
        (x) => x.chainName == this.selectedChain
      ).chainId;
      window.open(
        `${process.env.VUE_APP_FIXIT_NO_URL}/nettbutikk/${chainId}/`,
        "_self"
      );
    },
  },
  async created() {
    profileSvc = await ProfileSvc(this.$axios);
    this.loading = true;
    this.products = await profileSvc.GetFavoriteProducts(
      this.bookingApi,
      this.layout == "chain"
        ? this.$store.getters["salon/getSiteIds"]
          ? this.$store.getters["salon/getSiteIds"]
          : this.$store.getters["site/getChainSiteIds"]
        : []
    );
    this.filteredProducts = this.products;
    this.chains = this.products.length
      ? this.products.map((x) => x.chainName)
      : [];
    this.selectedChain = this.chains.length > 1 ? "" : this.chains[0];
    this.loading = false;
  },
  beforeDestroy() {
    profileSvc = null;
  },
};
</script>
